import { render, staticRenderFns } from "./main.vue?vue&type=template&id=8fd19dd4&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd19dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fd19dd4')) {
      api.createRecord('8fd19dd4', component.options)
    } else {
      api.reload('8fd19dd4', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=8fd19dd4&scoped=true", function () {
      api.rerender('8fd19dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabResultRegistration/main.vue"
export default component.exports